// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/tipi-documento?societaId=',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","societaId":"number","codice":"string","nome":"string","famiglia":"DDT_VENDITA|DDT_CANTIERE|SAL|FATTURA","causaleMovimentoId":"number|null","isDefault":"boolean","attivo":"boolean","note":"string|null","causaleMovimento":{"id":"number","codice":"string","descrizione":"string","tipo":"string"},"_count":{"ddt":"number","sal":"number"}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/causali-movimento?societaId=',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","societaId":"number","codice":"string","descrizione":"string","tipo":"CARICO|SCARICO|TRASFERIMENTO|RETTIFICA","attivo":"boolean"}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/tipi-documento',
    requestBody: '{"societaId":"number","codice":"string","nome":"string","famiglia":"DDT_VENDITA|DDT_CANTIERE|SAL|FATTURA","causaleMovimentoId":"number?","isDefault":"boolean?","note":"string|null"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/tipi-documento/:id',
    requestBody: '{"codice":"string?","nome":"string?","famiglia":"string?","causaleMovimentoId":"number|null","isDefault":"boolean?","attivo":"boolean?","note":"string|null"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/tipi-documento/:id',
    requestBody: '{"isDefault":true}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/tipi-documento/:id',
    requestBody: '{"attivo":"boolean"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/tipi-documento/:id',
    requestBody: null,
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
